import { ReactNode } from "react";
import styled from "styled-components";

const ToolTipText = styled("span")({
  visibility: "hidden",
  width: "fit-content",
  minWidth: "300px",
  maxWidth: "600px",
  backgroundColor: "#FFFFFF",
  color: "#123559",
  padding: "0.5rem",
  textAlign: "center",
  borderRadius: "6px",
  position: "absolute",
  zIndex: 1,
  left: "0",
  marginLeft: "-60px",
  //   "backdrop-filter": " blur(10px)",
  shadowColor: "#000",
  shadowOffset: {
    width: 0,
    height: 2,
  },
  shadowOpacity: 0.23,
  shadowRadius: 2.62,
  elevation: 4,
  //   ":after": {
  //     content: '""',
  //     position: "absolute",
  //     top: "100%",
  //     left: "50%",
  //     marginLeft: "-5px",
  //     borderWidth: "5px",
  //     borderStyle: "solid",
  //     borderColor: "black transparent transparent transparent",
  //   },

  boxShadow: "5px 5px 16px #cacaca,  -5px -5px 16px #f6f6f6",
});

const ToolTip = styled("div")({
  position: "relative",
  display: "inline-block",
  ":hover span": {
    visibility: "visible",
  },
});

const Too = ({
  children,
  toolTipText,
}: {
  children: ReactNode;
  toolTipText: string;
}) => (
  <ToolTip>
    {children}
    <ToolTipText>{toolTipText}</ToolTipText>
  </ToolTip>
);

export default Too;
